import {
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  REGISTER_REQUEST,
} from 'common-js/reducers/account/actionTypes';
import { CHANGE_CONTEXT } from 'common-js/reducers/organization/actionTypes';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { CLEAR, GET_PUBLIC_RELEASEFLAGS_SUCCESS, GET_RELEASEFLAGS_SUCCESS } from './actionTypes';

// Rather than hard-code all the individual Better Monetize the Product (BMP) flags, we want to generate the combinations programmatically. (So this creates `bmp_feature_lite_bulk_actions`, `bmp_feature_plus_bulk_actions`, etc.)
const BMPPackages = ['lite', 'plus', 'pro'];
const BMPFeatures = [
  'activity_history',
  'api',
  'bulk_actions',
  'data_usage_limits',
  'device_tunneling',
  'fleet_status',
  'predeployment_testing',
  'tags',
];
const BMPFlags = Object.fromEntries(
  BMPPackages.reduce<Array<[string, boolean]>>((flags, pkg) => {
    BMPFeatures.forEach((feature) => flags.push([`bmp_feature_${pkg}_${feature}`, false]));
    return flags;
  }, [])
);

export const initialState = {
  ...BMPFlags,
  activity_history_details: false,
  activity_history_export_csv: false,
  add_editor_limited_role: false,
  billing_statements: false,
  biz_layer_pause_resume: false,
  bulk_rename: false,
  bulk_tag: false,
  csrrdm_allowed: false,
  custom_billing: false,
  embedded_looker_reporting: false,
  eureka0: false,
  feature_data_usage_alerts: false,
  feature_predeployment: false,
  fleet: false,
  fleet_historic: false,
  gdpr: false,
  hyper_sdp_improvements: false,
  hyper_search_improvements: false,
  legacy_plans: false,
  liveusage: false,
  negative_balance: false,
  proplan: false,
  proxy_analytics: false,
  sdp_new_lights: false,
  service_advisory: false,
  service_outage: false,
  service_planned: false,
  stellar_design_system: false,
  support_gui: false,
};

function featureReducer(
  state = initialState,
  action: { type?: string; flags?: Array<string> | Record<string, string> } = {}
) {
  let newReleaseFlags: typeof initialState;

  switch (action.type) {
    case CLEAR:
    case LOGIN_REQUEST:
    case REGISTER_REQUEST:
    case LOGOUT_REQUEST:
    case CHANGE_CONTEXT:
      // Wipe our entire state, nothing should survive these actions.
      return structuredClone(initialState);

    case GET_PUBLIC_RELEASEFLAGS_SUCCESS:
    case GET_RELEASEFLAGS_SUCCESS: {
      newReleaseFlags = structuredClone(state);

      if (isArray(action.flags)) {
        action.flags.forEach((flag) => {
          newReleaseFlags[flag] = true;
        });
      } else if (isObject(action.flags)) {
        Object.values(action.flags).forEach((flag) => {
          newReleaseFlags[flag] = true;
        });
      }

      return newReleaseFlags;
    }

    default:
      return state;
  }
}

export default featureReducer;
